<script lang="ts">
    import { createEventDispatcher } from 'svelte';

    export let options: { value: string; label: string }[] = [];
    export let active: Set<string> = new Set();
    export let label: string = '';

    const dispatch = createEventDispatcher<{ toggle: string }>();
</script>

<div class="filter-chips" {...$$restProps}>
    {#if label}<span class="filter-label">{label}</span>{/if}
    {#each options as opt}
        <button
            class="chip chip--{opt.value}"
            class:active={active.has(opt.value)}
            on:click={() => dispatch('toggle', opt.value)}
            aria-pressed={active.has(opt.value)}
        >
            {#if active.has(opt.value)}
                <svg class="chip-icon" viewBox="0 0 24 24" width="18" height="18">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/>
                </svg>
            {/if}
            {opt.label}
        </button>
    {/each}
</div>
